const hom = [
    // 放在 OPay APP中的OKash的老版本下载页面
    {
        path: '/opdownload',
        name: 'opdownload',
        component: () => import('../views/hom/opdownload.vue'),
        meta: {
            'title': 'OKash'
        }
    },
    // 放在 OPay APP中的OKash的新版本下载页面（这里的新版本截止2022年11月份）
    {
        path: '/andownload',
        name: 'andownload',
        component: () => import('../views/hom/andownload.vue'),
        meta: {
            'title': 'OKash'
        }
    },
    // 首页-额度页
    {
        path: '/tips',
        name: 'Tips',
        component: () => import('../views/hom/tips.vue'),
        meta: {
            'title': 'OKash'
        }
    },
    {
        path: '/whats',
        name: 'Whats',
        component: () => import('../views/hom/whats.vue'),
        meta: {
            'title': 'OKash'
        }
    },
    {
        path: '/dangers',
        name: 'Dangers',
        component: () => import('../views/hom/dangers.vue'),
        meta: {
            'title': 'OKash'
        }
    },
    {
        path: '/introduce',
        name: 'Introduce',
        component: () => import('../views/hom/introduce.vue'),
        meta: {
            'title': 'OKash'
        }
    }
]

export default hom



// WEBPACK FOOTER //
// ./src/router/hom.js